//
// ChatSupportInfo - Component for displaying support information messages
// Shows medical or logistics support info with appropriate icons and formatting
//
//  const msg = {
//   qstnId: 'supportInfo',
//   msgTxt: 'this is more info 123',
//   kind: 'medical',
//   crUid: 3,
//   crAppId: 2,
//   msgType: 'form',
//   msgCdatim1: '2020-10-21 18:01:39.2',
//   msgIdAnswer: null,
//   msgId: 23,
//   msgUid: 6,
//   crUidAdd: 3,
//   id: 3,
// };

import PropTypes from 'prop-types';

import {
  Medical,
  Keys,
} from '../../../../assets/js/svg/gui';

import { MessageText } from './components';

const typeToIcon = {
  medical: <Medical className="h-7 w-7 mx-1 rounded-2xl" />,
  logistics: <Keys className="h-7 w-7 mx-1 rounded-2xl" />,
};

function ChatSupportInfo({
  translate,
  message,
}) {
  const { supportInfo } = message;
  const {
    txt,
    kind,
  } = supportInfo;
  const header = translate(`${kind}Info`);

  return ([
    <MessageText
      key="header"
      message={(
        <span className="h-9 w-full flex flex-row items-center">
          {typeToIcon[kind]}
          <i><b>{`${header}:`}</b></i>
        </span>
      )}
      author={null}
    />,

    <MessageText
      key="txt"
      message={txt || JSON.stringify(message)}
      author={null}
    />,
  ]);
}

ChatSupportInfo.propTypes = {
  translate: PropTypes.func.isRequired,
  message: PropTypes.shape({
    supportInfo: PropTypes.shape({
      kind: PropTypes.string,
      txt: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default ChatSupportInfo;
